import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class LogisticsVehiclesAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateSuccess() {
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // IMPORT //
  // The importer skips rows that fail create / update without failing the batch, so a finished
  // batch cannot be reported as a full success.
  importFinished() {
    const message = {
      body: 'LOGISTICS_VEHICLES_IMPORT_FINISHED'
    };
    return this.bringozToastService.success(message)
  }

  importError(error?) {
    const message = {
      body: 'IMPORT_ENTITIES_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  //////////////////////////////////////// DOCUMENTS ////////////////////////////////////////

  getDocumentsError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_GET_DOCUMENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
  createDocumentSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createDocumentError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  exportVehiclesSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_EXPORT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  exportVehiclesError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  updateDocumentSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateDocumentError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteDocumentSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_DELETE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteDocumentError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_DELETE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //////////////////////////////////////// REMINDERS ////////////////////////////////////////

  getRemindersError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_GET_REMINDERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
  createReminderSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createReminderError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_CREATE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateReminderSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateReminderError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UPDATE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteReminderSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_DELETE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteReminderError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_DELETE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  bindToAgentSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_BIND_TO_AGENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  bindToAgentError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_BIND_TO_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  unbindVehicleSuccess(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UNBIND_VEHICLE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  unbindVehicleError(){
    const message = {
      body: 'LOGISTICS_VEHICLE_UNBIND_VEHICLE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteVehicleSuccess(){
    const message = {
      body: 'DELETE_VEHICLE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteVehicleError(){
    const message = {
      body: 'DELETE_VEHICLE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .service('logisticsVehiclesAlertsService', LogisticsVehiclesAlertsService);
